import reactdom from 'react-dom';
import App from './App';
reactdom.render(<App />,document.getElementById("root"))
